var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAQuienVaDirigido(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.55661 16.5912C7.29688 16.5912 7.08609 16.3773 7.08609 16.1138V13.7457L0.90918 18.6213L7.08609 23.4968V21.1287C7.08609 20.8652 7.29688 20.6513 7.55661 20.6513H9.02781C10.1966 20.6513 11.1452 21.6157 11.1452 22.8016L11.1365 33.3373H14.4038L14.4143 17.5348C13.8779 16.9352 13.127 16.5914 12.3252 16.5914L7.55661 16.5912Z",
    fill: "#2A363B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8562 18.6619L29.6793 13.7864V16.1545C29.6793 16.418 29.4685 16.6319 29.2088 16.6319H24.4399C23.6363 16.6319 22.8853 16.9756 22.3508 17.5772L22.3892 33.3577H25.6566L25.6181 22.842C25.6181 21.6561 26.5686 20.6917 27.7374 20.6917H29.2086C29.4683 20.6917 29.6791 20.9056 29.6791 21.1691V23.5372L35.8562 18.6619Z",
    fill: "#2A363B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3155 0.643555L13.5105 6.91307H15.8443C16.1041 6.91307 16.3149 7.12695 16.3149 7.3905L16.3098 33.3418L18.2891 33.3577L20.3111 33.3418L20.3162 7.3905C20.3162 7.12695 20.527 6.91307 20.7867 6.91307H23.1205L18.3155 0.643555Z",
    fill: "#2A363B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAQuienVaDirigido);
export default __webpack_public_path__ + "static/media/a-quien-va-dirigido.661998e316525eede427f049248173d1.svg";
export { ForwardRef as ReactComponent };